import NiceModal, { useModal, antdModal } from '@ebay/nice-modal-react';
import AddEvent, { type IAddEventProps } from '@/components/AddEvent/index.jsx';
import VerdantProvider from '@/components/VerdantProvider.jsx';
import { toast } from 'sonner';

export type IAddModalProps = Pick<
  IAddEventProps,
  'planId' | 'date' | 'onSuccess' | 'orderIdx'
>;
const AddModal = NiceModal.create((props: IAddModalProps) => {
  const modal = useModal();

  return (
    <VerdantProvider>
      <AddEvent
        isOpen={modal.visible}
        {...props}
        onOpenChange={(payload) => {
          if (!payload) {
            modal.hide();
            setTimeout(() => {
              modal.remove();
            }, 500);
          }
        }}
      />
    </VerdantProvider>
  );
});

export default AddModal;
